/** @format */
import Master from '../../Layouts/Master';
import { useEffect, useState, useContext } from 'react';
import Logo from '../../../Assets/Images/logo.jpg';

import { EventContext } from '../../../Contexts/EventContext';
import useApi from '../../../Shared/hooks/api/Index';
import { error } from '../../../Shared/Components/Toast';
import Loading from '../../../Shared/Components/Loading';
import moment from 'jalali-moment';
import { number_format } from '../../../Shared/utils/helper';
import { useParams } from 'react-router';

const Factor = () => {
	const eventContext = useContext(EventContext);
	const { id, payment_id } = useParams();
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		getFactor();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id, payment_id]);
	const getFactor = async () => {
		setLoading(true);
		await useApi.get(
			`/panel/factor/${id}`,
			{},
			(res) => {
				eventContext.factor = res.data.data;
			},
			(err) => {
				setLoading(false);
				error('هنگام دریافت اطلاعات خطایی رخ داده است');
			},
		);
		await useApi.get(
			`/panel/report/payment/${payment_id}`,
			{},
			(res) => {
				eventContext.transaction = res.data.data;
				setLoading(false);
			},
			(err) => {
				setLoading(false);
				error('هنگام دریافت اطلاعات خطایی رخ داده است');
			},
		);
	};

	return loading ? (
		<Loading />
	) : (
		<Master>
			<div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
				<div className='d-flex flex-row mt-2'>
					<i className='fad fa-list f-20 text-secondary mx-2'></i>
					<h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
						فاکتور
					</h1>
				</div>
			</div>
			<div className='row'>
				<div className='border col-xl-8 col-md-12 mx-auto'>
					<div className='card-header d-flex flex-wrap'>
						<div className='invoice-header col-xl-8 float-right'>
							<strong className='float-right' style={{ marginTop: '50px' }}>
								{' '}
								فاکتور شماره {eventContext.factor?.id}#
							</strong>
						</div>
						<div className='col-xl-4 float-right text-left'>
							<img src={Logo} alt='logo' style={{ maxHeight: '78px' }} />
						</div>
						<div className='col-12 text-center'>
							<strong>
								فدراسیون بولینگ، بیلیارد و بولس جمهوری اسلامی ایران
							</strong>
						</div>
					</div>
					<div className='card-body'>
						<div className='col-xl-6 float-right p-5 border-left'>
							<h6>پرداخت شده برای</h6>
							<span className='desc-text'>
								{eventContext.factor?.user?.name}{' '}
								{eventContext.factor?.user?.last_name}
								<br />
								{eventContext.factor?.user?.national_card_id}
							</span>
						</div>
						<div className='col-xl-6 float-right p-5'>
							<h6>پرداخت به</h6>
							<span className='desc-text'>
								فدراسیون بولینگ، بیلیارد و بولس جمهوری اسلامی ایران
								<br />
							</span>
						</div>
						<div className='col-12'>
							<div className='col-xs-12 no-padding'>
								<div className='table-responsive'>
									<table className='table invoice-items'>
										<tbody>
											<tr>
												<td className='text-right'>
													<strong>توضیحات</strong>
												</td>
												<td className='text-center'>
													<strong>میزان</strong>
												</td>
											</tr>
											<tr>
												<td className='text-right'>شرکت در مسابقه</td>
												<td className='text-center'>
													{number_format(eventContext.factor?.price)} ریال
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
					<div className='card-footer'>
						<div className='col-xs-12 no-padding'>
							<div className='table-responsive'>
								<table className='table transactions-table'>
									<tbody>
										<tr>
											<td className='text-center'>
												<strong>تاریخ تراکنش</strong>
											</td>
											<td className='text-center'>
												<strong>دروازه پرداخت</strong>
											</td>
											<td className='text-center'>
												<strong>شماره پیگری</strong>
											</td>
											<td className='text-center'>
												<strong>شماره سفارش</strong>
											</td>
											<td className='text-center'>
												<strong>مبلغ</strong>
											</td>
										</tr>
										<tr>
											<td className='text-center'>
												{moment(
													eventContext.transaction?.created_at ?? '1990-01-01',
													'YYYY-MM-DD',
												)
													.locale('fa')
													.format('YYYY/MM/DD')}
											</td>
											<td className='text-center'>
												پرداخت آنلاین با کارت های شتاب
												<br />
												(سامان کیش)
											</td>
											<td className='text-center'>
												{eventContext.transaction?.tracking_id}
											</td>
											<td className='text-center'>
												{eventContext.transaction?.order_id}
											</td>
											<td className='text-center'>
												{number_format(eventContext.transaction?.amount)} ریال
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Master>
	);
};

export default Factor;
